module.exports = __webpack_public_path__ + "img/snowflake-regular.e0df1ac3.svg";